module.exports = __webpack_public_path__ + "static/media/people-icon.7b89ff88.svg";